import { BreadcrumbService } from '@core/services/layout/breadcrumbs.service';

export function breadcrumbsFactory(service: BreadcrumbService) {
  return () => service.init();
}
